"use strict";

(function() {

	/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
	/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
	/* Note: if many pages need cleaning up, it can be a solution to put in a script that is loaded in edit mode (eg link target, nbsp, empty tags) */
	if (!(document.querySelector("body").classList.contains("isEditing"))) {

		let elms, e;

		// Add rough image width information
		elms = document.querySelectorAll(".richtext img");
		for (e of elms) {
			e.addEventListener("load", function() {
				// event handler can not be added after .complete check or in an else condition,
				// because image could finish loading in between
				this.setAttribute("data-w100",Math.round(this.width/100));
				// note this is the specified width, not the intrinsic width, but that is also what we want
			})
			if (e.complete) {
				// in case image is already loaded when we arrive here
				e.setAttribute("data-w100",Math.round(e.width/100));
			}
		}

	}

})();
